import { cUtil }                    from "../../functions/util";
import { cAdminDeliveryItems }      from "./admin-delivery-items";
import { cAdminDeliveryItemsOrder } from "./admin-delivery-items-order";

export class cAdminDeliveryItemsItem {

  tr             = document.createElement('tr');
  td_status      = document.createElement('td');
  td_date        = document.createElement('td');
  td_product     = document.createElement('td');
  td_ordered     = document.createElement('td');
  td_delivered   = document.createElement('td');
  td_price       = document.createElement('td');
  td_totals      = document.createElement('td');
  td_note        = document.createElement('td');

  span_status    = document.createElement('span');
  input_date     = document.createElement('input');
  p_origDate     = document.createElement('p');

  p_name        = document.createElement('p');
  p_detail       = document.createElement('p');
  p_comment      = document.createElement('p');
  p_orphan       = document.createElement('p');
  p_unmatched    = document.createElement('p');
  p_ambiguous    = document.createElement('p');

  span_ordered   = document.createElement('span');
  p_amountDrift  = document.createElement('p');

  input_amount   = document.createElement('input');
  span_unit      = document.createElement('span');

  input_price    = document.createElement('input');
  p_priceDrift   = document.createElement('p');
  p_priceDev     = document.createElement('p');

  div_taxRate    = document.createElement('div');
  div_subTotal   = document.createElement('div');
  div_tax        = document.createElement('div');
  div_total      = document.createElement('div');

  input_note     = document.createElement('input');
  button_delete  = document.createElement('button');

  data    : DeliveryItemLine;
  page    : cAdminDeliveryItems;
  order   : cAdminDeliveryItemsOrder;
  saving  = false;
  // The entered delivery date differs from the ordered one (updateDateDeviation()).
  dateDeviation = false;

  constructor(parent: HTMLElement, data: DeliveryItemLine, page: cAdminDeliveryItems, order: cAdminDeliveryItemsOrder) {

    this.data  = data;
    this.page  = page;
    this.order = order;

    // ---- Structure ----
    parent.append(this.tr);
      this.tr.append(this.td_status);
        this.td_status.append(this.span_status);
      this.tr.append(this.td_date);
        this.td_date.append(this.input_date);
        this.td_date.append(this.p_origDate);
      this.tr.append(this.td_product);
        this.td_product.append(this.p_name);
        this.td_product.append(this.p_detail);
        this.td_product.append(this.p_comment);
        this.td_product.append(this.p_orphan);
        this.td_product.append(this.p_unmatched);
        this.td_product.append(this.p_ambiguous);
      this.tr.append(this.td_ordered);
        this.td_ordered.append(this.span_ordered);
        this.td_ordered.append(this.p_amountDrift);
      this.tr.append(this.td_delivered);
        this.td_delivered.append(this.input_amount);
        this.td_delivered.append(this.span_unit);
      this.tr.append(this.td_price);
        this.td_price.append(this.input_price);
        this.td_price.append(this.p_priceDrift);
        this.td_price.append(this.p_priceDev);
      this.tr.append(this.td_totals);
        this.td_totals.append(this.div_taxRate);
        this.td_totals.append(this.div_subTotal);
        this.td_totals.append(this.div_tax);
        this.td_totals.append(this.div_total);
      this.tr.append(this.td_note);
        this.td_note.append(this.input_note);
        if (data.unmatched) this.td_note.append(this.button_delete);

    // ---- Init ----
    this.td_status  .classList.add('c-status');
    this.td_ordered .classList.add('c-ordered-cell');
    this.td_totals  .classList.add('c-totals');
    this.p_detail   .classList.add('c-detail');
    this.p_origDate .classList.add('c-note');
    this.p_comment  .classList.add('c-comment');
    this.p_orphan   .classList.add('c-note');
    this.p_ambiguous.classList.add('c-note');
    this.p_unmatched.classList.add('c-tag');
    this.p_priceDrift .classList.add('c-note');
    this.p_priceDev   .classList.add('c-note');
    this.p_amountDrift.classList.add('c-note');
    this.span_ordered .classList.add('c-ordered');
    this.p_name       .classList.add('c-name');
    this.div_total    .classList.add('c-total');
    this.input_amount .classList.add('c-in-amount');
    this.input_price  .classList.add('c-in-price');
    this.input_note   .classList.add('c-in-note');
    this.span_unit    .classList.add('c-unit');

    this.input_date   .type = 'date';
    this.input_amount .type = 'number';
    this.input_price  .type = 'number';
    this.input_note   .type = 'text';

    this.input_amount .step = '0.001';
    this.input_price  .step = '0.01';
    this.input_amount .min  = '0';
    this.input_price  .min  = '0';

    this.input_date   .setAttribute('aria-label', 'Liefertermin');
    this.input_amount .setAttribute('aria-label', 'Geliefert');
    this.input_price  .setAttribute('aria-label', 'Preis');
    this.input_note   .setAttribute('aria-label', 'Lieferschein-Nr.');

    this.input_date    .value = data.new_delivery_date;
    this.input_amount  .value = data.new_total_amount;
    this.input_price   .value = data.new_price;
    this.input_note    .value = data.delivery_note_no;

    this.button_delete.type      = 'button';
    this.button_delete.innerText = 'Löschen';
    this.button_delete.classList.add('button-link', 'button-link-delete', 'c-delete');

    this.lock();

    this.p_name    .innerText = `${data.SKU} - ${data.order_item_name}`;
    this.p_detail  .innerText = data.detailLine;
    this.p_comment .innerText = data.comment;
    this.span_unit .innerText = data.price_unit;

    this.span_ordered.innerText =
      data.hasWooItem ? `${data.orig_total_amount.toFixed(3)} ${data.price_unit}` : '';

    this.updateDateDeviation();

    this.p_orphan.innerText =
      data.orphan ? 'Position in WooCommerce nicht mehr vorhanden' : '';

    // A delivery note line that the import could not assign. It stays in the section without an
    // order and is merged by hand: its values are copied over to the ordered position, then it is
    // deleted. It cannot be changed itself.
    this.p_unmatched.innerText = data.unmatched ? 'Nicht zugeordnet' : '';
    this.p_ambiguous.innerText = data.ambiguousNote;

    this.p_amountDrift.innerText =
      data.amountDrift ? `Aktuell: ${data.liveTotalAmount.toFixed(3)} ${data.price_unit}` : '';

    this.p_priceDrift.innerText =
      data.priceDrift ? `Aktuell: ${data.livePrice.toFixed(2)}` : '';

    this.updatePriceDeviation();

    this.updateTotals();
    this.validate();

    // ---- Events ----
    // The order is sorted by delivery date, but the line stays where it is until the page is
    // loaded again.
    this.input_date.addEventListener('change', () => {
      this.data.new_delivery_date = this.input_date.value;
      this.updateDateDeviation();
      this.validate();
      this.save();
    });

    // Weight and price change the delivered value, which the coupon is spread by.
    this.input_amount.addEventListener('change', () => {
      this.data.new_total_amount = this.input_amount.value;
      this.validate();
      this.updateTotals();
      this.order.redistributeCoupons();
      this.order.updateSum();
      this.save();
    });

    this.input_price.addEventListener('change', () => {
      this.data.new_price = this.input_price.value;
      this.updatePriceDeviation();
      this.validate();
      this.updateTotals();
      this.order.redistributeCoupons();
      this.order.updateSum();
      this.save();
    });

    this.input_note.addEventListener('change', () => {
      this.data.delivery_note_no = this.input_note.value;
      this.save();
    });

    this.button_delete.addEventListener('click', async () => {
      if (!window.confirm(`Nicht zugeordnete Lieferschein-Position «${this.p_name.innerText}» löschen?`)) return;

      this.button_delete.disabled = true;
      const result = await this.page.fetchDelete(this.data.id);
      if (!result.ok) {
        this.button_delete.disabled = false;
        this.page.toast(result.message, true);
        return;
      }
      this.page.toast(`${result.message}: ${this.data.order_item_name}`, false);
      this.order.removeItem(this);
    });
  }

  // A delivery note line without a counterpart is only deleted, and a captured order stays as wallee
  // got it. The server refuses a save of either (save.php).
  lock(): void {
    const reason = this.data.unmatched  ? 'Nicht zugeordnete Lieferschein-Position: nur löschen möglich'
                 : this.order.data.captured ? 'Bereits eingezogen'
                 : '';
    if (reason === '') return;

    for (const input of [this.input_date, this.input_amount, this.input_price, this.input_note]) {
      input.disabled = true;
      input.title    = reason;
    }
  }

  // The delivery date the customer ordered, shown only while the entered one differs from it. A
  // line ordered without a date, or without a counterpart, has nothing to compare against.
  updateDateDeviation(): void {
    const ordered = this.data.orig_delivery_date;
    this.dateDeviation = ordered !== '' && this.data.new_delivery_date !== ordered;
    this.p_origDate.innerText = this.dateDeviation ? `Bestellt: ${cUtil.isoToCh(ordered)}` : '';
  }

  // The price of the woocommerce line item, not the price that is valid today, shown as soon as the
  // entered price differs from it - the same test as finishLine() in data.php, which only runs on
  // loading the page. p_priceDrift shows the same number when the stored copy has fallen behind,
  // which is a different statement. A line without a counterpart has nothing to compare against.
  updatePriceDeviation(): void {
    const price = Number(this.data.new_price);
    this.data.priceDeviation =
      this.data.hasWooItem && this.data.new_price !== '' && !isNaN(price) &&
      Math.abs(this.data.livePrice - price) > 0.001;

    this.p_priceDev.innerText =
      this.data.priceDeviation ? `Bestellt: ${this.data.livePrice.toFixed(2)}` : '';
  }

  // The delivered weight is mandatory, an empty field is an error. 0 is valid and means
  // "not delivered", so it must not be treated as empty.
  hasError(): boolean {
    const dateOk   = this.data.new_delivery_date !== '';
    const priceOk  = this.data.new_price         !== '' && !isNaN(Number(this.data.new_price));
    const amountOk = this.data.new_total_amount  !== '' && !isNaN(Number(this.data.new_total_amount));
    return !dateOk || !priceOk || !amountOk;
  }

  validate(): void {
    this.mark(this.input_date  , this.data.new_delivery_date === '');
    this.mark(this.input_price , this.data.new_price === '' || isNaN(Number(this.data.new_price)));
    this.mark(this.input_amount, this.data.new_total_amount === '' || isNaN(Number(this.data.new_total_amount)));
    this.updateStatus();
  }

  mark(elm: HTMLInputElement, hasError: boolean): void {
    if (hasError) elm.classList.add('c-error-outline');
    else          elm.classList.remove('c-error-outline');
  }

  // Vor Steuern, kaufmännisch on 5 Rappen. The rounded value is what is shown and what the tax is
  // calculated from, so line and sums stay consistent with each other.
  subTotal(): number | null {
    if (this.hasError()) return null;
    return cUtil.swissRound(Number(this.data.new_total_amount) * Number(this.data.new_price));
  }

  // The tax of a single line, kaufmännisch on 5 Rappen as well. Every sum above adds these rounded
  // values up and is not rounded again, so the shown Steuer of the lines and the Liefersumme agree.
  tax(): number | null {
    const sub = this.subTotal();
    if (sub === null) return null;
    return cUtil.swissRound(sub * this.data.tax_rate / 100);
  }

  // Vor Steuern as ordered, rounded the same way. 0 for a line without a woocommerce counterpart.
  orderedSubTotal(): number {
    return cUtil.swissRound(this.data.orig_total_amount * this.data.orig_price);
  }

  // The delivered value of the line, before the coupons. They stand on their own rows below and
  // are taken off in the Liefersumme.
  lineTotal(): number | null {
    const sub = this.subTotal();
    const tax = this.tax();
    if (sub === null || tax === null) return null;
    return sub + tax;
  }

  updateTotals(): void {
    const sub   = this.subTotal();
    const tax   = this.tax();
    const total = this.lineTotal();

    this.div_taxRate  .innerHTML = '';
    this.div_subTotal .innerHTML = '';
    this.div_tax      .innerHTML = '';
    this.div_total    .innerHTML = '';

    this.row(this.div_taxRate , 'Steuersatz' , `${this.data.tax_rate.toFixed(2)}%`);
    this.row(this.div_subTotal, 'Vor Steuern', sub   === null ? '–' : sub.toFixed(2));
    this.row(this.div_tax     , 'Steuer'     , tax   === null ? '–' : tax.toFixed(2));
    this.row(this.div_total   , 'Total'      , total === null ? '–' : total.toFixed(2));
  }

  row(parent: HTMLElement, label: string, value: string): void {
    const span_label = document.createElement('span');
    const span_value = document.createElement('span');
    span_label.innerText = label;
    span_value.innerText = value;
    parent.append(span_label);
    parent.append(span_value);
  }

  updateStatus(justSaved = false): void {
    const error   = this.hasError();
    const info    = this.data.orphan || this.data.priceDrift || this.data.amountDrift ||
                    this.data.priceDeviation || this.dateDeviation;
    const noLink  = this.data.order_item_id === 0;

    this.span_status.className = 'c-icon';
    this.span_status.innerText = '';
    this.span_status.title     = '';

    if (error) {
      this.span_status.classList.add('c-icon-error');
      this.span_status.innerText = '!';
      this.span_status.title     = 'Pflichtfeld fehlt';
      return;
    }
    if (justSaved) {
      this.span_status.classList.add('c-icon-saved');
      this.span_status.innerText = '✓';
      this.span_status.title     = 'Gerade gespeichert';
      return;
    }
    if (info) {
      this.span_status.classList.add('c-icon-info');
      this.span_status.innerText = 'i';
      this.span_status.title     =
        this.data.orphan ? 'Position in WooCommerce nicht mehr vorhanden' : 'Abweichung zur Bestellung';
      return;
    }
    if (noLink) {
      this.span_status.classList.add('c-icon-muted');
      this.span_status.innerText = '–';
      this.span_status.title     = 'Keine WooCommerce-Verknüpfung';
    }
  }

  async save(): Promise<void> {
    if (this.hasError()) return;
    if (this.saving) return;
    this.saving = true;

    const result = await this.page.fetchLine(this.data, 'c_delivery_item_save');
    this.saving  = false;

    if (!result.ok) {
      this.page.toast(result.message, true);
      return;
    }

    this.data.id = result.id;
    this.updateStatus(true);
    this.page.toast(`${result.message}: ${this.data.order_item_name}`, false);

    window.setTimeout(() => this.updateStatus(), 2600);
  }

  getData(): DeliveryItemLine {
    return this.data;
  }
}
